<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout px-2 wrap justify-center>
      <v-flex xs12 sm12 md12 lg10 xl8 text-left>
        <v-layout py-4 wrap>
          <v-flex xs6 text-left>
            <span
              style="font-family:opensansbold;font-size:20px;color:#000000;"
              class="text-capitalize"
            >Your Orders</span>
          </v-flex>
          <v-flex xs6 text-right>
            <v-icon>mdi-view-module</v-icon>
            <v-icon>mdi-view-sequential</v-icon>
          </v-flex>
        </v-layout>
        <v-layout wrap pb-4>
          <v-flex>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout v-for="(item,i) in orders" :key="i" wrap>
          <v-flex px-4 xs12 md2>
            <v-layout wrap justify-center>
              <v-flex xs2 v-for="(photos,j) in item.product" :key="j">
                <v-img :src="baseURL+'/u/'+photos.photos[0]" height="100px" contain></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md8>
            <v-layout wrap>
              <v-flex xs12>
                <router-link :to="'/'+item.product[0]._id+'/'+item.product[0].productname">
                  <span
                    style="font-family:opensansbold;font-size:16px;color:#000000;"
                  >{{item.productname}}</span>
                </router-link>
              </v-flex>
              <v-flex xs12>
                <span
                  style="font-family:opensansbold;font-size:16px;color:#000000;"
                >Price: ₹ {{item.amount}}</span>
              </v-flex>
              <v-flex xs12>
                <span v-for="(item,i) in 3" :key="i">
                  <v-icon color="#FFC107" size="14px">mdi-star</v-icon>
                </span>
                <span v-for="(item,i) in 2" :key="i">
                  <v-icon size="14px">mdi-star-outline mdi-dark mdi-inactive</v-icon>
                </span>
                <span style="font-family:opensansregular;font-size:12px;color:#292929;">1205 Rated</span>
              </v-flex>
              <v-flex xs12>
                <span
                  style="font-family:opensansregular;font-size:12px;color:#616161;"
                >Inclusive of all taxes</span>
              </v-flex>
              <v-flex xs12>
                <span style="font-family:opensansregular;font-size:14px;color:#63028F;">
                  <i>You Save: ₹0</i>
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="font-family:opensansregular;font-size:14px;color:#000000;"
                >Shipping Charge: ₹0</span>
              </v-flex>
              <v-flex xs12>
                <span
                  style="font-family:opensansregular;font-size:12px;color:#616161;"
                >Item Added {{formatDate(item.init_date)}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 md2>
            <v-layout wrap fill-height>
              <!-- <v-flex xs12 text-right>
                <v-icon>mdi-delete</v-icon>
              </v-flex>-->
              <v-flex xs12 align-self-end>
                <v-btn
                  small
                  dark
                  depressed
                  block
                  :ripple="false"
                  color="#63028F"
                  :to="'/MyOrders/'+item._id"
                >
                  <span
                    style="font-family:opensansregular;font-size:12px;"
                    class="text-capitalize"
                  >View Details</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex py-4 xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      menu: false,
      appLoading: false,
      orders: [],
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/myorders",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.orders = response.data.data;
          console.log(response.data.data);
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      return strTime;
    },
  },
};
</script>